import {
  PosVendaProtocoloPrioridade,
  PosVendaProtocoloStatus,
} from '../../types/posVenda';
import { PROTOCOLO_PRIORIDADE_LABEL, PROTOCOLO_STATUS_LABEL } from './posVendaLabels';

const STATUS_KEYS = Object.keys(PROTOCOLO_STATUS_LABEL) as PosVendaProtocoloStatus[];
const PRIORIDADE_KEYS: PosVendaProtocoloPrioridade[] = ['Baixa', 'Normal', 'Alta'];

/** A API serializa enums em camelCase (`emAnalise`, `aguardandoCliente`). */
export function enumIgnorandoCaixa<T extends string>(
  valor: string | null | undefined,
  chaves: readonly T[]
): T | undefined {
  const alvo = (valor ?? '').trim().toLowerCase();
  if (!alvo) return undefined;
  return chaves.find((chave) => chave.toLowerCase() === alvo);
}

export function statusCanonicFromApi(status: string | null | undefined): PosVendaProtocoloStatus {
  return enumIgnorandoCaixa(status, STATUS_KEYS) ?? 'Aberto';
}

export function prioridadeCanonicaFromApi(
  prioridade: string | null | undefined
): PosVendaProtocoloPrioridade {
  return enumIgnorandoCaixa(prioridade, PRIORIDADE_KEYS) ?? 'Normal';
}

export function labelStatusProtocolo(status: string | null | undefined): string {
  if (!status?.trim()) return '—';
  const canon = enumIgnorandoCaixa(status, STATUS_KEYS);
  if (canon) return PROTOCOLO_STATUS_LABEL[canon];
  return status;
}

export function labelPrioridadeProtocolo(prioridade: string | null | undefined): string {
  if (!prioridade?.trim()) return '—';
  const canon = prioridadeCanonicaFromApi(prioridade);
  return PROTOCOLO_PRIORIDADE_LABEL[canon] ?? prioridade;
}

export const PROTOCOLO_STATUS_TODOS: PosVendaProtocoloStatus[] = [...STATUS_KEYS];
